import { memo, type FC } from "react";
import { View, Text } from "@src/components";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { Icon } from "@src/components/Icon";
import { capitalize } from "@src/utils/capitalize";

interface AlarmStateBadgeProps {
  state: "armed" | "disarmed" | "modified" | "removed";
}

export const AlarmStateBadge: FC<AlarmStateBadgeProps> = memo(({ state }) => {
  const { theme } = useUnistyles();
  const badge = theme.colors.alarmStateBadges[state];

  const iconName =
    state === "removed" ? "delete"
    : state === "modified" ? "edit"
    : state === "armed" ? "lockClosed"
    : "lockOpen";

  return (
    <View
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      gap="xxs"
      style={[
        styles.badge,
        {
          backgroundColor: badge.background as string,
          borderColor: badge.border as string,
        },
      ]}
    >
      <Icon name={iconName} color={badge.foreground as string} size={12} />
      <Text textStyle="xxs/regular" style={{ color: badge.foreground as string }}>
        {state === "removed" ?
          "Removed"
        : state === "modified" ?
          "Modified"
        : capitalize(state)}
      </Text>
    </View>
  );
});

const styles = StyleSheet.create((theme) => ({
  badge: {
    borderWidth: 1,
    borderRadius: theme.spacing["3xl"],
    paddingHorizontal: theme.spacing.sm,
    paddingVertical: theme.spacing.xs,
  },
}));
